import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PuceIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<ellipse cx="13" cy="12.48" rx="4" ry="3.84" fill="currentColor" />
		</svg>
	);
}

PuceIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PuceIcon;
